// extracted by mini-css-extract-plugin
export default {"speciesName":"speciesName__SpeciesName__wGNHt","prominent":"prominent__SpeciesName__wGNHt"};